import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { logout } from '../../actions/authActions';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { LogOut } from 'lucide-react';

export class Logout extends Component {
  static propTypes = {
    logout: PropTypes.func.isRequired,
    className: PropTypes.string,
    navigate: PropTypes.func
  };

  handleLogout = () => {
    this.props.logout();
    // Redirect to home page
    window.location.href = '/';
  };

  render() {
    const { className = "flex items-center w-full px-4 py-3 text-sm text-[#1e2d40] hover:bg-[#f9fafb] hover:text-[#1086a4] transition-colors duration-200" } = this.props;
    
    return (
      <Fragment>
        <button
          onClick={this.handleLogout}
          className={className}
          style={{ boxSizing: 'border-box' }}
        >
          <LogOut className="w-4 h-4 mr-3" />
          Logout
        </button>
      </Fragment>
    );
  }
}

export default connect(
  null,
  { logout }
)(Logout);
